import React from 'react';

import classes from './AfterTitleRow.module.css';

const afterTitleRow = (props) => (
    <div className={classes.ColumnSelectionWrapper}>
        {props.children}
    </div>
);

export default afterTitleRow;